import errorMessage from 'global_config/error_messages';

const FIELD_RULES = {
	Username: [
		{ required: true, message: 'Required Field!' },
		{ max: 20, message: errorMessage.maxLength(20) }
	],
	password: [
		{ required: true, message: 'Required Field!' },
		{ max: 20, message: errorMessage.maxLength(20) }
	],
};

export default FIELD_RULES;
